import { render, staticRenderFns } from "./CCWrapper.vue?vue&type=template&id=cd525e40&scoped=true&"
import script from "./CCWrapper.vue?vue&type=script&lang=js&"
export * from "./CCWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd525e40",
  null
  
)

export default component.exports